const colors = {
  primary: "#12c4b7",
  secondary: "#00536F",
  lightGray: "#C3C3C3",
  lightish: "#F5FAFA",
};

export default colors;
